import { apiDelete, apiGet, apiPost, apiPut } from './api-service';


export async function siteJobTasksAdd(ids: number[]) {
    try {
        return await apiPost('core', `site-job-task`, {
            job_task: ids
        });
    } catch (e) { }
}

export async function siteJobTaskDelete(id: any) {
    try {
        return await apiDelete('core', `site-job-task/${id}`);
    } catch (e) { }
}